import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport200084Status: 'idle',
    startReport200084Error: undefined as any,
    loadUserParamsReport200084Status: 'idle',
    loadUserParamsReport200084Error: undefined as any,

    report200084List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport200084 = createAsyncThunk('report200084Slice/startReport200084', async ({ report200084 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport200084/`,
        prepareData(report200084),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport200084Status } = getState().report200084Slice
        return startReport200084Status !== 'pending'
    }
})

export const loadUserParamsReport200084 = createAsyncThunk('report200084Slice/loadUserParamsReport200084', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport200084/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport200084Status } = getState().report200084Slice
        return loadUserParamsReport200084Status !== 'pending'
    }
})

const Report200084Slice = createSlice({
    name: 'report200084Slice',
    initialState,
    reducers: {
        resetstartReport200084: (state) => {
            state.job = undefined
            state.startReport200084Error = undefined
        },
        resetstartReport200084Error: (state) => {
            state.startReport200084Error = undefined
        },
        resetloadUserParamsReport200084: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport200084Error = undefined
        },
        resetloadUserParamsReport200084Error: (state) => {
            state.loadUserParamsReport200084Error = undefined
        },
        removeFromReport200084ListById: (state, action) => {
            state.report200084List = state.report200084List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport200084ListByIds: (state, action) => {
            state.report200084List = state.report200084List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report200084List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport200084Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report200084List = []
            state.startReport200084Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport200084.pending, (state) => {
            state.startReport200084Status = 'pending'
            state.startReport200084Error = undefined
        })
        builder.addCase(startReport200084.fulfilled, (state, action) => {
            state.startReport200084Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport200084.rejected, (state, action) => {
            state.startReport200084Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport200084Error = action.error.message
            } else {
                state.startReport200084Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport200084.pending, (state) => {
            state.loadUserParamsReport200084Status = 'pending'
            state.loadUserParamsReport200084Error = undefined
        })
        builder.addCase(loadUserParamsReport200084.fulfilled, (state, action) => {
            state.loadUserParamsReport200084Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport200084.rejected, (state, action) => {
            state.loadUserParamsReport200084Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport200084Error = action.error.message
            } else {
                state.loadUserParamsReport200084Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport200084,
    resetstartReport200084Error,
    resetloadUserParamsReport200084,
    resetloadUserParamsReport200084Error,
    removeFromReport200084ListById,
    removeFromReport200084ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report200084Slice.actions
export default Report200084Slice.reducer
